<template>
    <div class="modal-container">
        <div class="modal-header">
            <h4 class="modal-title">Edit Item</h4>
        </div>
        <div class="modal-body">
            <form-wrapper :validator="$v" class="form-wrapper">
                <div class="item-barcode">
                    <form-group name="barcode" label="Barcode">
                        <md-input v-model="barcode" v-focus />
                    </form-group>
                </div>
                <div class="item-description">
                    <form-group name="description" label="Description">
                        <md-input v-model="description" />
                    </form-group>
                </div>
                <div v-if="showAllFields" class="item-description">
                    <form-group name="sku" label="SKU">
                        <md-input v-model="sku" />
                    </form-group>
                </div>
                <div v-if="showAllFields" class="item-description">
                    <form-group name="productReference" label="Product Reference">
                        <md-input v-model="productReference" />
                    </form-group>
                </div>
                <div class="item-description">
                    <form-group name="installationTime" label="Installation Time In Minutes">
                        <md-input v-model.number="installationTimeInMinutes" />
                    </form-group>
                </div>
                <div v-if="loadFieldList !== null">
                    <load-inputs
                        v-for="(load, index) in loadFieldList"
                        :key="index"
                        :load-definition="load"
                        :initial-value="loadValues"
                        @changed="handleLoadChanged"
                    />
                </div>
            </form-wrapper>
        </div>
        <div class="modal-footer">
            <md-button class="md-primary dialog-button" @click="onSaveClick">
                Save
            </md-button>
            <md-button class="md-default dialog-button" @click.stop="onCancelClick">
                Cancel
            </md-button>
        </div>
    </div>
</template>

<script>
import { GeneralMixin } from '@/mixins/GeneralMixin';
import { required } from 'vuelidate/lib/validators';
import { mapGetters } from 'vuex';
import { handleRequests, showErrorMessage } from '@/helpers';
import { LoadInputs } from '@/components';

export default {
    name: 'StopLineModal',
    mixins: [GeneralMixin],
    components: { LoadInputs },
    props: {
        item: {
            type: Object,
            default: () => null
        },
        resolve: {
            type: Function,
            default: () => {}
        },
        showAllFields: {
            type: Boolean,
            default: () => false
        }
    },
    validations: {
        barcode: {
            required
        }
    },
    data() {
        return {
            barcode: this.item.barcode,
            description: this.item.description,
            sku: this.item.sku,
            productReference: this.item.productReference,
            installationTimeInMinutes: this.item.installationTimeInMinutes,
            loadFieldList: [],
            loadValues: this.item.load || {}
        };
    },
    computed: {
        ...mapGetters({
            user: 'user/user'
        })
    },
    mounted() {
        this.loadFieldList = [];
        if (this.user.vehicleCapacityUnitsConfiguration && this.user.vehicleCapacityUnitsConfiguration.length > 0) {
            this.loadFieldList = this.user.vehicleCapacityUnitsConfiguration.filter((x) => x.type !== 'quantity');
        }
    },
    methods: {
        async onSaveClick() {
            if (this.$v.$invalid) {
                showErrorMessage(this, 'Barcode is required');
                return;
            }

            this.$_handleLoaderState(true, 'UPDATING...');
            const payload = {
                method: 'put',
                data: {
                    barcode: this.barcode,
                    description: this.showAllFields ? this.description || '' : this.description,
                    sku: this.showAllFields ? this.sku || '' : this.sku,
                    productReference: this.productReference,
                    installationTimeInMinutes:
                        this.installationTimeInMinutes === '' ? null : this.installationTimeInMinutes,
                    load: this.loadValues
                }
            };
            try {
                const api = `/api/items/${this.item.itemId}`;
                await handleRequests(api, payload);

                this.$notify({
                    message: `Item updated!`,
                    type: 'success'
                });
                this.$v.$reset();

                this.resolve({
                    updated: true,
                    item: payload.data
                });
            } catch (e) {
                const message = 'Cannot update item.';
                showErrorMessage(this, message);
                this.resolve({
                    updated: false,
                    item: null
                });
            }
            this.$_handleLoaderState(false);
        },
        onCancelClick() {
            this.resolve({
                updated: false,
                item: this.item
            });
        },
        handleLoadChanged({ name, value }) {
            this.loadValues[name] = !Number.isNaN(value) ? value : 0;
        }
    }
};
</script>

<style lang="scss" scoped>
.modal-container {
    max-width: 600px;
}
</style>
